var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{staticClass:"pushMsgDialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[_c('push-msg-form',{ref:"outform",on:{"open-dialog":_vm.openDialog,"send-success":_vm.sendSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }